export default "__VITE_ASSET__B8wuEdPa__"